// extracted by mini-css-extract-plugin
module.exports = {"no-results":"no-results_no-results__8fyTI","no-results__text":"no-results_no-results__text__gwo_o"};